import React, { useEffect, useContext } from "react"
import * as styles from "./breadcrumb.module.scss"
import { Link } from "@reach/router"
import { useLink, useLocalPath } from "../../hooks/index"

import { useValidateBreadcrumb } from "../../hooks/index.ts"
import { GoHomeFill } from "react-icons/go"

import { mapLocale } from "../../utils/mapping.js"
import { LocaleContext } from "../../context/context.js"

type Props = {
  data: { slug: string; title: string }[]
  title: string
}

const Breadcrumb = ({ data, title }: Props) => {
  const { isValid, jsonLd } = useValidateBreadcrumb({ data, title })

  useEffect(() => {
    if (isValid && jsonLd) {
      const script = document.createElement("script")
      script.type = "application/ld+json"
      script.text = JSON.stringify(jsonLd)
      document.head.appendChild(script)

      return () => {
        document.head.removeChild(script)
      }
    }
  }, [isValid, jsonLd])

  function toSentenceCase(str: string) {
    if (!str || str.length === 0) {
      return ""
    }
    const firstChar = str.charAt(0).toUpperCase()
    const restOfStr = str.slice(1).toLowerCase()

    return firstChar + restOfStr
  }

  const { locale } = useContext(LocaleContext)
  const localePrefix = mapLocale[locale] || "in/en"

  const isRTL = localePrefix.startsWith("mena/ar")

  return (
    <div className={`${styles.strip}`}>
      <div className={` ${styles.wrapper}`}>
        <a href={`${useLink("/")}`} aria-label="Home">
          <GoHomeFill className={styles.homeSvg} />
        </a>
        <svg
          className={`${styles.arrowSvg} ${isRTL ? styles.flipArrow : ""}`}
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
        >
          <path
            d="M12.6 12.5L8 7.9L9.4 6.5L15.4 12.5L9.4 18.5L8 17.1L12.6 12.5Z"
            fill="#777586"
          />
        </svg>

        {data.map((item: { slug: string; title: string }, id: number) => {
          if (item.title?.toLowerCase() === "home") {
            return null
          }
          return (
            <span key={id}>
              <a href={`${useLink(item.slug)}`}>{toSentenceCase(item.title)}</a>

              <svg
                className={`${styles.arrowSvg} ${
                  isRTL ? styles.flipArrow : ""
                }`}
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
              >
                <path
                  d="M12.6 12.5L8 7.9L9.4 6.5L15.4 12.5L9.4 18.5L8 17.1L12.6 12.5Z"
                  fill="#777586"
                />
              </svg>
            </span>
          )
        })}

        <span className={styles.breadcrumTitle}>
          {toSentenceCase(title.split(" / ").join(" ").toLowerCase())}
        </span>
      </div>
    </div>
  )
}

export default Breadcrumb
